module.exports = __webpack_public_path__ + "static/media/vw-logo.6d93e7a5.png";